



























import {
  computed,
  defineComponent,
  PropType,
  ref
} from '@nuxtjs/composition-api'
import CTimeInput from '~/components/shared/configurable/datetime/CTimeInput.vue'
import { ciCalendarFa } from '~/icons/source/regular/calendar-fa'
import { AuditRequest, AuditRequestStatusStatus } from '~/models/audit/request'
import AuditAppointmentForm from '~/components/shared/audits/request/AuditAppointmentForm.vue'
import CancelAuditButton from '~/components/shared/audits/request/timeline/CancelAuditButton.vue'

export default defineComponent({
  components: {
    CancelAuditButton,
    CTimeInput,
    AuditAppointmentForm
  },
  props: {
    auditRequest: {
      type: Object as PropType<AuditRequest>,
      required: true
    }
  },
  setup(_props, { emit }) {
    const appointmentFormIsShown = ref(false)

    const datepickerMinDate = computed(() => {
      return new Date()
    })

    function handleAppointmentSuccess() {
      emit(
        'change-status',
        AuditRequestStatusStatus.INFORMING_USER_ABOUT_APPOINTMENT
      )
    }

    return {
      appointmentFormIsShown,
      ciCalendarFa,
      datepickerMinDate,
      handleAppointmentSuccess
    }
  }
})
